import React, { FunctionComponent, ReactNode } from "react";
import { useIntl } from "react-intl";
import deliveryIcon from "./images/icon-address.svg";
import billingIcon from "./images/icon-billing.svg";
import "./style.scss";

interface Props {
  children: ReactNode;
  type: "delivery" | "billing";
}

const CartAddressContainer: FunctionComponent<Props> = ({ children, type }) => {
  const intl = useIntl();
  const description = intl.formatMessage({ id: `cheerz_CartAddressContainer_${type}` });
  const icon = type === "billing" ? billingIcon : deliveryIcon;

  return (
    <div className="CartAddressContainer">
      <div className="CartAddressContainer-icon">
        <img alt={description} className="CartAddressContainer-icon-image" src={icon} />
        <div className="CartAddressContainer-icon-description">{description}</div>
      </div>
      <div className="CartAddressContainer-content">{children}</div>
    </div>
  );
};

export default CartAddressContainer;
